import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import ContactTwo from "../elements/contact/ContactTwo";
import BrandTwo from "../elements/BrandTwo";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import HeaderAbs from "../component/header/HeaderAbs";
import FooterTwo from "../component/footer/FooterTwo";

class Contact extends Component{
    render(){
        const linkedinUrl = "https://www.linkedin.com/in/temefford";
        const githubUrl = "https://www.github.com/temefford";

        return(
            <React.Fragment>
                <PageHelmet
                    pageTitle="Contact"
                    description="Contact Theo Mefford (AI Architect & FDE) via the contact form, LinkedIn, or GitHub."
                    canonical="https://www.theomefford.com/contact"
                />

                <HeaderAbs homeLink="/" logo="symbol-dark" color="color-black" />

                 {/* Start Breadcrump Area */}
                 <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--17"  data-black-overlay="6">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">Get in touch</h2>
                                    <p>Use the form below to reach me. I’m also active on LinkedIn and GitHub.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}


                {/* Start Contact Top Area  */}
                <div className="rn-contact-top-area ptb--120 bg_color--5">
                    <div className="container">
                       
                        <div className="row">
                            {/* Start Single Address  */}
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12 mt_mobile--50">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FaLinkedinIn />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">LinkedIn</h4>
                                        <p><a href={linkedinUrl} rel="noopener noreferrer" target="_blank">{linkedinUrl}</a></p>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Address  */}

                            {/* Start Single Address  */}
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12 mt_md--50 mt_sm--50">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FaGithub />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">GitHub</h4>
                                        <p><a href={githubUrl} rel="noopener noreferrer" target="_blank">{githubUrl}</a></p>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Address  */}

                        </div>
                    </div>
                </div>
                {/* End Contact Top Area  */}

                {/* Start Contact Page Area  */}
                <div className="rn-contact-page ptb--120 bg_color--1">
                    <ContactTwo />
                </div>
                {/* End Contact Page Area  */}
                

                {/* Start Brand Area */}
                <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <FooterTwo />
                
            </React.Fragment>
        )
    }
}
export default Contact
